module.exports = __webpack_public_path__ + "img/web_22.463c5403.png";